import { Box, Skeleton } from "@mui/material";

export default function WeatherReportsProtocolSummarySkeleton() {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 2,
                padding: 2,
                borderBottom: theme => `1px solid ${theme.palette.divider}`,
            }}
        >
            <Box>
                <Skeleton variant="text" width={120} height={16} />
                <Skeleton variant="text" width={100} height={24} />
            </Box>
            <Box>
                <Skeleton variant="text" width={100} height={16} />
                <Skeleton variant="text" width={60} height={24} />
            </Box>
            <Box>
                <Skeleton variant="text" width={130} height={16} />
                <Skeleton variant="text" width={80} height={24} />
            </Box>
        </Box>
    );
}
